<template lang="pug">
    .login
        Layout
            Content.loginContent(:style="loginPageContentStyle")
                div(:style="backgroundLogoStyle")
                    Card.loginCard(dis-hover)
                        img(src="" v-real-img="loginImgs.loginFormLogoImgName" style="min-width:300px;max-width: 350px;margin: 10px 0 ")
                        Divider(v-if="loginDescription!== ''")
                        p.loginDescription(v-if="loginDescription!== ''") {{ loginDescription }}
                        //- .loginDescriptionBlock(v-else)
                        Form.loginInput(
                            ref="signupByResetPasswordForm",
                            :model="loginForm",
                            :rules="loginRules"
                        )
                            FormItem(prop="username")
                                Input(
                                    @on-enter="handleSubmit"
                                    type="text"
                                    v-model="loginForm.username"
                                    placeholder="Username"
                                    suffix="md-person"
                                    
                                )
                            FormItem(prop="password")
                                Input(
                                    @on-enter="handleSubmit"
                                    type="password"
                                    password
                                    v-model="loginForm.password"
                                    placeholder="new Password"
                                )
                            FormItem(prop="otpToken")
                                Input.otpInput(
                                    @on-enter="handleSubmit"
                                    v-model="loginForm.otpToken"
                                    placeholder="Token"
                                    suffix="md-key"
                                )
                            FormItem
                                Button.loginBtn(@click="handleSubmit") Login
</template>
<script>
import { _login } from "@/api/user";
import { validateResetpasswordToken, validateResetPassword } from "@/api/user";

export default {
    name: "ResetPassword",
    data() {
        return {
            loginForm: {
                username: "",
                password: "",
                otpToken: "",
            },
            loginRules: {
                username: [
                    {
                        required: true,
                        message: "Please fill in the user name",
                        trigger: "change",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "Please fill in the password.",
                        trigger: "change",
                    },
                ],
                otpToken: [
                    {
                        required: true,
                        message: "Please fill in the token.",
                        trigger: "change",
                    },
                ],
            },
            tokenDecrypt: {
                username: "",
                email: "",
                operator: "",
                currentTaskNumber: "",
            },
        };
    },
    created() {},
    mounted() {
        let { token } = this.$route.query;
        if (token == undefined) {
            // this.$Notice.warning({
            //     title: this.$i18n.t("global.error"),
            //     desc: `token not find`,
            // });
            this.$router.push({ name: "login" });
        }
        validateResetpasswordToken({ token })
            .then((res) => {
                if (!res.data.success) throw new Error(res.data.msg);

                if (!res.data.data.userExist) {
                    // this.$Notice.warning({
                    //     title: this.$i18n.t("global.error"),
                    //     desc: `User is Exist`,
                    // });
                    this.$router.push({ name: "login" });
                }

                this.tokenDecrypt = res.data.data.tokenDecrypt;
                // this.loginForm.username = this.tokenDecrypt.username;
            })
            .catch((err) => {
                console.log(err);
                // this.$Notice.warning({
                //     title: this.$i18n.t("global.error"),
                //     desc: `${err}`,
                // });
                this.$router.push({ name: "login" });
            });
    },
    methods: {
        handleSubmit() {
            this.$refs.signupByResetPasswordForm.validate((valid) => {
                if (!valid) return;
                let { token } = this.$route.query;
                validateResetPassword({ token, data: this.loginForm })
                    .then((res) => {
                        if (res.data.success !== true) throw new Error(res.data.message);
                        this.$Notice.success({
                            title: this.$i18n.t("global.success"),
                            desc: `${res.data.success}`,
                        });
                        this.$router.push({ name: "login" });
                    })
                    .catch((err) => {
                        console.log(err);
                        // this.$Notice.warning({
                        //     title: this.$i18n.t("global.error"),
                        //     desc: `${err}`,
                        // });
                    });
            });
        },
    },
    computed: {
        loginDescription: function () {
            return this.$store.getters.getLoginDescription;
        },
        loginImgs: function () {
            return this.$store.getters.getLoginPageImgs;
        },
        loginPageContentStyle() {
            return {
                background: `url(${this.loginImgs.backgroundImgName}) no-repeat center center`,
                overflow: "hidden",
                "background-size": "cover",
                "background-color": this.$store.getters["getBrandName"] == "A8CDN" ? "rgba(0, 0, 0, 0.4)" : "",
                "background-blend-mode": this.$store.getters["getBrandName"] == "A8CDN" ? "multiply" : "",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
            };
        },
        backgroundLogoStyle() {
            return {
                width: "100vw",
                height: "100vh",
                background: `url(${this.loginImgs.backgroundLogoImgName}) no-repeat center center`,
                "background-size": "auto 90%",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
            };
        },
    },
};
</script>
<style scoped>
.loginCard {
    background: transparent;
    border: none;
    text-align: center;
}
.ivu-input-wrapper >>> .ivu-input-suffix {
    padding-right: 15px;
}

.ivu-input-wrapper >>> .ivu-input-suffix i {
    line-height: 40px;
}
.signup-description {
    font-size: 28px;
    color: #fff;
    margin-bottom: 24px;
}
@media screen and (min-width: 1280px) {
    .signup-description {
        font-size: 28px;
    }
}
@media (max-width: 1080px) and (min-width: 960px) {
    .signup-description {
        font-size: 24px;
    }
}
@media screen and (max-width: 960px) {
    .signup-description {
        font-size: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/general/ResetPassword.vue